<template>
  <div v-if="showModuloForm === false">
    <MarketingModules></MarketingModules>
  </div>
  <div class="page" v-else-if="showModuloForm === true">
    <v-tabs v-model="aba" class="mb-4" :dark="darkEnabled">
      <v-tab>Agendamentos</v-tab>
      <v-tab>Métricas</v-tab>
    </v-tabs>
    <AgendamentosNotificacaoPush v-if="aba === ABA_AGENDAMENTOS" />
    <Panel v-show="aba === ABA_METRICAS" lineColor="var(--primary-color)">
      <template v-slot:header>
        <h3 class="panel-title">Relatório de Notificações Push</h3>
      </template>
      <template v-slot:options>
        <v-col cols="auto" class="mr-auto align-self-center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-card
                elevation="4"
                class="distinct-count-card"
                v-bind="attrs"
                v-on="on"
              >
                <v-card-text class="distinct-count-card__content">
                  <v-icon small class="distinct-count-card__icon">
                    fas fa-bell
                  </v-icon>
                  <span class="distinct-count-card__label">
                    Mensagens distintas
                  </span>
                  <span
                    class="distinct-count-card__separator"
                    aria-hidden="true"
                  />
                  <span class="distinct-count-card__value">
                    <v-progress-circular
                      v-if="loadingDistinctCount"
                      indeterminate
                      size="18"
                      width="2"
                      :color="distinctCountLoaderColor"
                    />
                    <span v-else>{{
                      formatDistinctCount(totalDistinctMessages)
                    }}</span>
                  </span>
                </v-card-text>
              </v-card>
            </template>
            Total de mensagens únicas enviadas no período selecionado
          </v-tooltip>
        </v-col>
        <v-col sm="6" md="3" lg="2" xl="2">
          <FormButton
            text="Atualizar Métricas"
            type="auxiliar"
            full
            @click="refreshMetrics"
          />
        </v-col>
      </template>
      <DataTable
        :headers="headers"
        :endpoint="endpoint"
        :filters="filters"
        sortBy="data_envio"
        :sortDesc="true"
        ref="datatable"
        @click="onRowClick"
        @set-value-filter="loadDistinctCount"
        noHideFilters
      >
        <template v-slot:data_envio="{ col }">
          {{ formatDate(col) }}
        </template>

        <template v-slot:titulo="{ row, col }">
          <div
            class="text-truncate"
            style="max-width: 250px;"
            :title="row.titulo"
          >
            {{ col }}
          </div>
        </template>

        <template v-slot:idagendamento="{ col }">
          {{ origemEnvio(col) }}
        </template>

        <template v-slot:usuario_nome="{ col }">
          {{ col || "-" }}
        </template>

        <template v-slot:fornecedor_nome="{ col }">
          {{ col || "-" }}
        </template>

        <template v-slot:metricas_successful="{ col }">
          <span v-if="col != null && col !== ''">{{ formatNumber(col) }}</span>
          <span v-else class="text-muted">-</span>
        </template>

        <template v-slot:entregues_aplicativo="{ row }">
          <span>{{ entreguesPorCanal(row, "aplicativo") }}</span>
        </template>

        <template v-slot:entregues_navegador="{ row }">
          <span>{{ entreguesPorCanal(row, "navegador") }}</span>
        </template>

        <template v-slot:metricas_converted="{ col }">
          <span v-if="col != null && col !== ''">{{ formatNumber(col) }}</span>
          <span v-else class="text-muted">-</span>
        </template>

        <template v-slot:metricas_failed="{ col }">
          <span v-if="col != null && col !== ''">{{ formatNumber(col) }}</span>
          <span v-else class="text-muted">-</span>
        </template>

        <template v-slot:metricas_updated_at="{ col }">
          <span v-if="col" class="text-caption text-muted">
            {{ formatDateRelative(col) }}
          </span>
          <span v-else class="text-muted">-</span>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn
            icon
            small
            @click.stop="openDetails(item)"
            title="Ver detalhes"
          >
            <v-icon small>fas fa-eye</v-icon>
          </v-btn>
        </template>
      </DataTable>
    </Panel>
    <transition name="slide-popup" mode="out-in">
      <router-view class="view" @close="onClose"></router-view>
    </transition>
  </div>
</template>

<script>
import Panel from "@/components/Panel";
import DataTable from "@/components/DataTable";
import FormButton from "@/components/form/FormButton";
import { mapGetters } from "vuex";
import MarketingModules from "@/components/MarketingModules";
import { ModulesEnum } from "@/store/actions/modulesEnum";
import { MARKETING_PUSH_COUNT_DISTINCT_ENVIOS } from "@/store/actions/marketing";
import moment from "moment";
import AgendamentosNotificacaoPush from "./AgendamentosNotificacaoPush";
import { origemEnvio } from "./agendamento-helpers";

const ABA_AGENDAMENTOS = 0;
const ABA_METRICAS = 1;

export default {
  name: "RelatorioNotificacaoPush",
  components: {
    AgendamentosNotificacaoPush,
    Panel,
    DataTable,
    FormButton,
    MarketingModules
  },
  data() {
    return {
    ABA_AGENDAMENTOS,
    ABA_METRICAS,
    aba:
      this.$route && this.$route.query.aba === "agendamentos"
        ? ABA_AGENDAMENTOS
        : ABA_METRICAS,
    refreshingMetrics: false,
    totalDistinctMessages: 0,
    loadingDistinctCount: false,
    headers: [
      {
        text: "Data Envio",
        value: "data_envio",
        width: "150px"
      },
      {
        text: "Título",
        value: "titulo",
        sortable: false
      },
      {
        text: "Origem",
        value: "idagendamento",
        sortable: false,
        width: "100px"
      },
      {
        text: "Usuário",
        value: "usuario_nome",
        sortable: false
      },
      {
        text: "Fornecedor",
        value: "fornecedor_nome",
        sortable: false
      },
      {
        text: "Entregues",
        value: "metricas_successful",
        align: "center",
        sortable: false,
        width: "100px"
      },
      {
        text: "Entregues (App)",
        value: "entregues_aplicativo",
        align: "center",
        sortable: false,
        width: "120px"
      },
      {
        text: "Entregues (Navegador)",
        value: "entregues_navegador",
        align: "center",
        sortable: false,
        width: "150px"
      },
      {
        text: "Cliques",
        value: "metricas_converted",
        align: "center",
        sortable: false,
        width: "100px"
      },
      {
        text: "Falhas",
        value: "metricas_failed",
        align: "center",
        sortable: false,
        width: "100px"
      },
      {
        text: "Últ. Atualização",
        value: "metricas_updated_at",
        sortable: false,
        width: "140px"
      }
    ],
    modulosForm: [
      ModulesEnum.ORCAMENTO_WEB,
      ModulesEnum.ORCAMENTO_APP,
      ModulesEnum.WEB_COMMERCE,
      ModulesEnum.COMMERCE_APP
    ]
    };
  },
  computed: {
    ...mapGetters(["getFornecedorId", "moduloFornecedorAtivo", "darkEnabled"]),
    distinctCountLoaderColor() {
      return this.darkEnabled ? "grey darken-3" : "white";
    },
    showModuloForm() {
      return this.moduloFornecedorAtivo(this.modulosForm);
    },
    endpoint() {
      return `/api/web/internal/v2/marketing/push/envios?idfornecedor=${
        this.getFornecedorId
      }${this.refreshingMetrics ? "&refreshMetrics=true" : ""}`;
    },
    filters() {
      return [
        {
          label: "Data Início",
          query: "dataInicio",
          type: "date",
          clearable: true
        },
        {
          label: "Data Fim",
          query: "dataFim",
          type: "date",
          clearable: true
        },
        {
          label: "Usuário",
          query: "idusuario",
          type: "autocomplete",
          clearable: true,
          request: {
            endpoint: `/api/web/internal/v2/marketing/push/usuarios/${this.getFornecedorId}`,
            query: "search",
            value: "idusuario",
            text: "nome"
          }
        }
      ];
    }
  },
  mounted() {
    this.loadDistinctCount(this.filters);
  },
  methods: {
    origemEnvio,
    onClose() {
      this.$refs.datatable.reload();
    },
    loadDistinctCount(value) {
      if (!this.getFornecedorId) {
        return;
      }

      this.loadingDistinctCount = true;
      const filtro =
        value && value.filtrosAvancados ? value.filtrosAvancados : value;
      const filtros = filtro || this.filters;

      const dataInicioFiltro = filtros.find(f => f.query === "dataInicio");
      const dataFimFiltro = filtros.find(f => f.query === "dataFim");
      const usuarioFiltro = filtros.find(f => f.query === "idusuario");

      const params = {
        idusuario:
          usuarioFiltro && usuarioFiltro.value ? usuarioFiltro.value : "",
        dataInicio:
          dataInicioFiltro && dataInicioFiltro.value
            ? dataInicioFiltro.value
            : "",
        dataFim: dataFimFiltro && dataFimFiltro.value ? dataFimFiltro.value : ""
      };

      this.$store
        .dispatch(MARKETING_PUSH_COUNT_DISTINCT_ENVIOS, params)
        .then(totalDistinct => {
          this.totalDistinctMessages = totalDistinct;
        })
        .catch(() => {
          this.totalDistinctMessages = 0;
        })
        .finally(() => {
          this.loadingDistinctCount = false;
        });
    },
    refreshMetrics() {
      this.refreshingMetrics = true;
      this.$refs.datatable.reload();
      const filtrosAtuais = this.$refs.datatable?.filtrosAvancados;
      this.loadDistinctCount(
        filtrosAtuais ? { filtrosAvancados: filtrosAtuais } : this.filters
      );
      setTimeout(() => {
        this.refreshingMetrics = false;
      }, 500);
    },
    formatDistinctCount(num) {
      if (num === null || num === undefined) {
        return "0";
      }
      return Number(num).toLocaleString("pt-BR");
    },
    onRowClick(item) {
      this.$router.push(
        `/fornecedor/marketing/push-notification/relatorio/${item.id}`
      );
    },
    formatDate(date) {
      if (!date) return "-";
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
    formatDateRelative(date) {
      if (!date) return "-";
      return moment(date)
        .locale("pt-br")
        .fromNow();
    },
    formatNumber(num) {
      if (num === null || num === undefined) return "-";
      return num.toLocaleString("pt-BR");
    },
    // entregues por canal, agregado pelo server em metricas_por_canal
    entreguesPorCanal(row, canal) {
      const total =
        row && row.metricas_por_canal && row.metricas_por_canal[canal]
          ? row.metricas_por_canal[canal].successful
          : null;
      return this.formatNumber(total);
    },
    openDetails(item) {
      this.$router.push(
        `/fornecedor/marketing/push-notification/relatorio/${item.id}`
      );
    }
  }
};
</script>

<style scoped>
.panel-title {
  margin: 0;
  font-size: 1.2rem;
  color: var(--primary-color);
}

.text-muted {
  color: #999;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.v-data-table >>> tbody tr {
  cursor: pointer;
}

.v-data-table >>> tbody tr:hover {
  background-color: #f5f5f5 !important;
}

.distinct-count-card {
  border-radius: 12px !important;
  background: #12558c !important;
  color: rgba(255, 255, 255, 0.92);
  min-width: auto;
}

.distinct-count-card >>> .v-card__text {
  padding: 10px 16px !important;
}

.distinct-count-card__content {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  white-space: nowrap;
  gap: 0;
  line-height: 1;
}

.distinct-count-card__icon {
  flex-shrink: 0;
  margin-right: 10px !important;
  color: rgba(255, 255, 255, 0.85) !important;
}

.distinct-count-card__label {
  font-size: 0.8125rem;
  font-weight: 500;
  letter-spacing: 0.02em;
  color: rgba(255, 255, 255, 0.95);
}

.distinct-count-card__separator {
  width: 1px;
  height: 18px;
  margin: 0 12px;
  background: rgba(255, 255, 255, 0.22);
  flex-shrink: 0;
}

.distinct-count-card__value {
  font-size: 1.125rem;
  font-weight: 700;
  color: #fff;
  min-height: 24px;
  display: inline-flex;
  align-items: center;
}
</style>
